import script from "./CustomTextField.vue?vue&type=script&lang=ts&setup=true"
export * from "./CustomTextField.vue?vue&type=script&lang=ts&setup=true"

import "./CustomTextField.vue?vue&type=style&index=0&id=681da476&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-681da476"]])

export default __exports__